import { replaceInChain } from "@insite/client-framework/HandlerCreator";

import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart, GetCartApiParameter, updateCart } from "@insite/client-framework/Services/CartService";

import { chain, NavigateToReturnUrl } from "@insite/client-framework/Store/Context/Handlers/SignIn";

import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, NavigateToReturnUrl, async props => {
    if (!props.authenticatedSession) {
        return;
    }
    const state = props.getState();
    let returnUrl = props.parameter.returnUrl;
    // const dashboardPageUrl = getPageLinkByPageType(props.getState(), "MyAccountPage")?.url;
    const dashboardPageUrl = getPageLinkByPageType(props.getState(), "HomePage")?.url;

    const defaultUrl =
        props.authenticatedSession.dashboardIsHomepage && dashboardPageUrl
            ? dashboardPageUrl
            : props.authenticatedSession.customLandingPage
            ? props.authenticatedSession.customLandingPage
            : "";

    const orderApprovalDetailsPageUrl = getPageLinkByPageType(props.getState(), "OrderApprovalDetailsPage")?.url;
    const bypassDefaultUrlIfOrderDetails =
        props.parameter.returnUrl &&
        orderApprovalDetailsPageUrl &&
        props.parameter.returnUrl.toLowerCase().indexOf(orderApprovalDetailsPageUrl.toLowerCase()) > -1 &&
        (props.parameter.returnUrl.toLowerCase().indexOf("external-approval=") > -1 ||
            props.parameter.returnUrl.toLowerCase().indexOf("external-approval-view=") > -1);

    if (defaultUrl !== "" && !bypassDefaultUrlIfOrderDetails && !returnUrl) {
        window.location.href = defaultUrl;
        return;
    }

    const checkoutShippingUrl = getPageLinkByPageType(state, "CheckoutShippingPage")?.url;

    if (returnUrl?.toLowerCase() === checkoutShippingUrl?.toLowerCase()) {
        const cartResult = await getCart({
            cartId: API_URL_CURRENT_FRAGMENT,
            expand: ["cartLines", "hiddenproducts"],
        } as GetCartApiParameter);

        const { canCheckOut, canBypassCheckoutAddress } = cartResult.cart;
        const checkoutReviewAndSubmitUrl = getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage")?.url;
        const cartUrl = getPageLinkByPageType(state, "CartPage")?.url;

        if (!canCheckOut || props.authenticatedSession.isRestrictedProductExistInCart) {
            returnUrl = cartUrl;
        } else if (canBypassCheckoutAddress) {
            returnUrl = checkoutReviewAndSubmitUrl;
        }
    }

    if (returnUrl?.includes("SwitchingLanguage")) {
        returnUrl = returnUrl.split("?")[0];
    }

    const homePageUrl = getHomePageUrl(state);
    if (returnUrl?.toLowerCase() === homePageUrl.toLowerCase() && props.authenticatedSession?.customLandingPage) {
        // need to send to custom landing page if the return URL is a language specific homepage
        if (returnUrl?.endsWith("/")) {
            returnUrl = returnUrl.substring(0, returnUrl.length - 1);
        }
        if (props.authenticatedSession?.customLandingPage.startsWith("/")) {
            returnUrl = `${returnUrl}${props.authenticatedSession?.customLandingPage}`;
        } else {
            returnUrl = `${returnUrl}/${props.authenticatedSession?.customLandingPage}`;
        }
    } else if (
        returnUrl?.toLowerCase() === homePageUrl.toLowerCase() &&
        props.authenticatedSession.dashboardIsHomepage &&
        dashboardPageUrl
    ) {
        // case where returnUrl is a language-specific homepage but we should redirect to the dashboard
        returnUrl = defaultUrl;
    }

    window.location.href = returnUrl || homePageUrl;
});
